import { Resource } from 'src/app/shared/models/resource.model';
import { Translation } from 'src/app/shared/models/translation.model';
import { FilterTranslate } from '../filter-translate.model';

/**Interfaccia che rappresenta lo stato a livello della pagina di traduzioni*/
//TODO da modificare non appena concordati i parametri da tenere in memoria
export interface State {
    /**Risorsa selezionata in navigazione */
    selectedResource: Resource;
    /**Valori dei filtri */
    filters: FilterTranslate;
    /**Risorsa o traduzione selezionata in tabella */
    selectedRow: Resource|Translation;
    /**Array delle risorse o traduzione in selezione secondaria in tabella */
    secondarySelectedRows: (Resource|Translation)[];
}

/**Stato iniziale per le traduzioni */
export const initialState: State = {} as State;